import {useState, useEffect} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {getOrder, cancelOrder} from '../api/orderApi';
import styles from './OrderDetailPage.module.css';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

function OrderDetailPage() {
    const {orderId} = useParams();
    const navigate = useNavigate();
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadOrder = async () => {
            try {
                const response = await getOrder(orderId);
                setOrder(response.data);
            } catch(err) {
                console.error('주문 로딩 실패', err);
                navigate('/orders');
            } finally {
                setLoading(false);
            }
        };
        loadOrder();
    }, [orderId]);

    const handleCancel = async () => {
        if(!window.confirm('주문을 취소하시겠습니까?')) return;
        try {
            const response = await cancelOrder(orderId);
            setOrder(response.data);
            alert('주문이 취소되었습니다.');
        } catch(err) {
            alert('주문 취소에 실패했습니다.');
        }
    };

    const statusLabel = {
        PENDING: '결제 대기',
        PAID: '결제 완료',
        SHIPPING: '배송 중',
        DELIVERED: '배송 완료',
        CANCELLED: '주문 취소'
    };

    if(loading) return <p className={styles.loading}>로딩 중...</p>;
    if(!order) return null;

    return (
        <div className={styles.container}>
            <button className={styles.backButton} onClick={() => navigate('/orders')}>
                ← 주문 내역
            </button>

            <h2 className={styles.title}>주문 상세</h2>

            <div className={styles.orderInfo}>
                <div className={styles.infoRow}>
                    <span className={styles.label}>주문번호</span>
                    <span>{order.orderId}</span>
                </div>
                <div className={styles.infoRow}>
                    <span className={styles.label}>주문일시</span>
                    <span>{new Date(order.createdAt).toLocaleString()}</span>
                </div>
                <div className={styles.infoRow}>
                    <span className={styles.label}>주문상태</span>
                    <span className={styles[order.status.toLowerCase()]}>
                        {statusLabel[order.status]}
                    </span>
                </div>
            </div>

            {/* 배송지 */}
            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>배송지</h3>
                <p>{order.address.recipient} · {order.address.phone}</p>
                <p>{order.address.address1} {order.address.address2}</p>
            </div>

            {/* 주문 상품 */}
            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>주문 상품</h3>
                {order.orderItems.map(item => (
                    <div key={item.orderItemId} className={styles.orderItem}>
                        <img
                            src={`${API_URL}${item.imageUrl}`}
                            alt={item.productName}
                            className={styles.itemImage}
                            onClick={() => navigate(`/products/${item.productId}`)}
                        />
                        <div className={styles.itemInfo}>
                            <p className={styles.itemName}>{item.productName}</p>
                            <p className={styles.itemQuantity}>{item.quantity}개</p>
                        </div>
                        <p className={styles.itemPrice}>{item.price.toLocaleString()}원</p>
                    </div>
                ))}
            </div>

            {/* 결제 금액 */}
            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>결제 금액</h3>
                <div className={styles.totalRow}>
                    <span>총 결제금액</span>
                    <span className={styles.totalPrice}>{order.totalPrice.toLocaleString()}원</span>
                </div>
            </div>

            {order.status === 'PENDING' && (
                <button className={styles.cancelButton} onClick={handleCancel}>
                    주문 취소
                </button>
            )}
        </div>
    );

}

export default OrderDetailPage;